// Formatting helpers shared across admin pages.
export const formatFollowers = (n) => {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(0)}K`;
  return `${n}`;
};

export const formatINR = (paise) => {
  if (paise >= 10_000_000) return `₹${(paise / 10_000_000).toFixed(2)}Cr`;
  if (paise >= 100_000) return `₹${(paise / 100_000).toFixed(1)}L`;
  if (paise >= 1000) return `₹${(paise / 1000).toFixed(0)}K`;
  return `₹${paise}`;
};

export const CAMPAIGN_STAGES = [
  "Lead",
  "Proposal Sent",
  "Negotiation",
  "Active",
  "Deliverables Pending",
  "In Review",
  "Completed",
  "Paid",
  "Archived",
];

export const LEAD_STAGES = [
  "New Lead",
  "Contacted",
  "Demo Scheduled",
  "Proposal Sent",
  "Negotiation",
  "Closed Won",
  "Closed Lost",
];
